export const TICK_CADENCE_DEGRADED_THRESHOLD_MS = 750

export interface ITickCadenceDegradedDetectInput {
  nowMs: number
  documentVisible: boolean
  queueLength: number
  lastTickAtMs: number | null
  suppressBecauseRegistrationResync: boolean
}

export interface ITickCadenceDegradedStatus {
  suspected: boolean
  gapMs: number
}

export function detectTickCadenceDegraded(input: ITickCadenceDegradedDetectInput): ITickCadenceDegradedStatus {
  const {
    nowMs,
    documentVisible,
    queueLength,
    lastTickAtMs,
    suppressBecauseRegistrationResync
  } = input

  if (!documentVisible || queueLength < 1 || lastTickAtMs == null || lastTickAtMs <= 0 || suppressBecauseRegistrationResync) {
    return { suspected: false, gapMs: 0 }
  }

  const gapMs = Math.max(0, nowMs - lastTickAtMs)
  return {
    suspected: gapMs > TICK_CADENCE_DEGRADED_THRESHOLD_MS,
    gapMs
  }
}
